unit ClaimAdjustmentsPopup;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Grid.Plugins,
  smx.webcore.types,
  WEBLib.Lists,
  WebForm.Core;

type
  TClaimAdjustmentsPopup = class(TCoreWebForm)
    ClaimAdjData: TXDataWebDataSet;
    ClaimAdjSource: TDataSource;
    ClaimAdjTable: TDBTableControl;
    ClaimAdjCloseButton: TButton;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    cbPageSize: TComboBox;
    ClaimAdjTitleLabel: TLabel;
    ClaimAdjDataId: TIntegerField;
    ClaimAdjDataTransactionDate: TDateField;
    ClaimAdjDataGiftAid: TFloatField;
    ClaimAdjDataAmount: TFloatField;
    ClaimAdjDataClaimStatus: TStringField;
    ClaimAdjDataClaimId: TIntegerField;
    ClaimAdjDataTaxYear: TIntegerField;
    ClaimAdjDataComment: TStringField;
    ClaimAdjDataAdjustmentType: TStringField;
    ClaimAdjDataLinkedDonationId: TIntegerField;
    procedure WebFormCreate(Sender: TObject);
    procedure ClaimAdjCloseButtonClick(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure ClaimAdjDataAdjustmentTypeGetText(Sender: TField; var Text: string;
        DisplayText: Boolean);
    procedure ClaimAdjDataGiftAidGetText(Sender: TField; var Text: string;
        DisplayText: Boolean);
    procedure ClaimAdjDataLinkedDonationIdGetText(Sender: TField; var Text: string;
        DisplayText: Boolean);
  private
    FClaimId: Integer;
    FTaxYear: Integer;
    FClaimStatus: string;
    FGridPlugin: TGridPlugin;
    FTitle: string;
    FClaimRef: string;
    function TitleCaption: string;
  public
    destructor Destroy; override;
    procedure AfterCreated; override;
    property ClaimId: Integer write FClaimId;
    property TaxYear: Integer write FTaxYear;
    property ClaimStatus: string write FClaimStatus;
    property PopupTitle: string write FTitle;
    property ClaimRef: string write FClaimRef;
  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses
  MainDataModule,
  SMX.Web.Utils,
  GA.Web.Utils;

procedure TClaimAdjustmentsPopup.WebFormCreate(Sender: TObject);
begin
  inherited;
  FGridPlugin := nil;
  ClaimAdjData.Connection := MainData.DataConnection;
end;

destructor TClaimAdjustmentsPopup.Destroy;
begin
  FGridPlugin.Free;
  FGridPlugin := nil;
  inherited;
end;

procedure TClaimAdjustmentsPopup.ClaimAdjCloseButtonClick(Sender: TObject);
begin
  ModalResult := mrOK;
end;

procedure TClaimAdjustmentsPopup.cbPageSizeChange(Sender: TObject);
begin
  if Assigned(FGridPlugin) then
    FGridPlugin.SetPageSize(StrToIntDef(Trim(cbPageSize.Text), 10), True);
end;

procedure TClaimAdjustmentsPopup.ClaimAdjDataAdjustmentTypeGetText(Sender: TField;
    var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.SplitOnCaps(Sender.AsString);
end;

procedure TClaimAdjustmentsPopup.ClaimAdjDataGiftAidGetText(Sender: TField;
    var Text: string; DisplayText: Boolean);
begin
  if Sender.IsNull then
    Text := ''
  else
    Text := FormatFloat('#,##0.00', Sender.AsFloat);
end;

procedure TClaimAdjustmentsPopup.ClaimAdjDataLinkedDonationIdGetText(Sender: TField;
    var Text: string; DisplayText: Boolean);
begin
  if Sender.IsNull or (Sender.AsInteger <= 0) then
    Text := ''
  else
    Text := Sender.AsInteger.ToString;
end;

function TClaimAdjustmentsPopup.TitleCaption: string;
var
  lSuffix: string;
begin
  lSuffix := TDonationUIUtils.ClaimPopupTitleSuffix(FClaimRef, FTaxYear);
  if SameText(FTitle, 'GASDS Adjustments in this claim') then
  begin
    if lSuffix <> '' then
      Result := 'GASDS ' + lSuffix
    else
      Result := 'GASDS';
  end
  else
    Result := lSuffix;
end;

procedure TClaimAdjustmentsPopup.AfterCreated;
var
  lFilter: string;
begin
  inherited;

  if FClaimId <= 0 then
    Exit;

  ClaimAdjTitleLabel.Caption := TitleCaption;

  // ClaimId only. Adjustment.TaxYear is the transaction tax year; ClaimStats.TaxYear
  // is the claim's year. Filtering both would hide the rows that belong to this claim.
  lFilter := Format('ClaimId eq %d and %s',
    [FClaimId, TDonationUIUtils.ClaimScopedStatusODataFilter(FClaimStatus)]);

  ClaimAdjData.Close;
  ClaimAdjData.QueryString := '$filter=' + lFilter;

  if not Assigned(FGridPlugin) then
  begin
    FGridPlugin := TGridPlugin.Create(ClaimAdjTable, ClaimAdjData, lcPaginator,
      lbPaginationInfo, TSortPair.Create(0, sdDesc));
    FGridPlugin.SetPageSize(StrToIntDef(Trim(cbPageSize.Text), 10));
  end;

  FGridPlugin.Load;
end;

procedure TClaimAdjustmentsPopup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ClaimAdjTitleLabel := TLabel.Create('ClaimAdjTitle');
  lbPaginationInfo := TLabel.Create('ClaimAdjPageInfo');
  cbPageSize := TComboBox.Create('ClaimAdjPageSizeSelect');
  ClaimAdjTable := TDBTableControl.Create('ClaimAdjTable');
  ClaimAdjCloseButton := TButton.Create('ClaimAdjCloseButton');
  lcPaginator := TListControl.Create('ClaimAdjPagination');
  ClaimAdjSource := TDataSource.Create(Self);
  ClaimAdjData := TXDataWebDataSet.Create(Self);
  ClaimAdjDataId := TIntegerField.Create(Self);
  ClaimAdjDataTransactionDate := TDateField.Create(Self);
  ClaimAdjDataGiftAid := TFloatField.Create(Self);
  ClaimAdjDataAmount := TFloatField.Create(Self);
  ClaimAdjDataClaimStatus := TStringField.Create(Self);
  ClaimAdjDataClaimId := TIntegerField.Create(Self);
  ClaimAdjDataTaxYear := TIntegerField.Create(Self);
  ClaimAdjDataComment := TStringField.Create(Self);
  ClaimAdjDataAdjustmentType := TStringField.Create(Self);
  ClaimAdjDataLinkedDonationId := TIntegerField.Create(Self);

  ClaimAdjTitleLabel.BeforeLoadDFMValues;
  lbPaginationInfo.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  ClaimAdjTable.BeforeLoadDFMValues;
  ClaimAdjCloseButton.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  ClaimAdjSource.BeforeLoadDFMValues;
  ClaimAdjData.BeforeLoadDFMValues;
  ClaimAdjDataId.BeforeLoadDFMValues;
  ClaimAdjDataTransactionDate.BeforeLoadDFMValues;
  ClaimAdjDataGiftAid.BeforeLoadDFMValues;
  ClaimAdjDataAmount.BeforeLoadDFMValues;
  ClaimAdjDataClaimStatus.BeforeLoadDFMValues;
  ClaimAdjDataClaimId.BeforeLoadDFMValues;
  ClaimAdjDataTaxYear.BeforeLoadDFMValues;
  ClaimAdjDataComment.BeforeLoadDFMValues;
  ClaimAdjDataAdjustmentType.BeforeLoadDFMValues;
  ClaimAdjDataLinkedDonationId.BeforeLoadDFMValues;
  try
    Name := 'ClaimAdjustmentsPopup';
    Width := 850;
    Height := 560;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    ClaimAdjTitleLabel.SetParentComponent(Self);
    ClaimAdjTitleLabel.Name := 'ClaimAdjTitleLabel';
    ClaimAdjTitleLabel.Left := 16;
    ClaimAdjTitleLabel.Top := 8;
    ClaimAdjTitleLabel.Width := 200;
    ClaimAdjTitleLabel.Height := 15;
    ClaimAdjTitleLabel.Caption := '                                           ';
    ClaimAdjTitleLabel.ElementPosition := epIgnore;
    ClaimAdjTitleLabel.HeightStyle := ssAuto;
    ClaimAdjTitleLabel.WidthStyle := ssAuto;
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 16;
    lbPaginationInfo.Top := 480;
    lbPaginationInfo.Width := 112;
    lbPaginationInfo.Height := 15;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.WidthStyle := ssAuto;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 16;
    cbPageSize.Top := 40;
    cbPageSize.Width := 80;
    cbPageSize.Height := 23;
    cbPageSize.ElementClassName := 'form-select';
    cbPageSize.ElementFont := efCSS;
    cbPageSize.ElementPosition := epIgnore;
    cbPageSize.HeightStyle := ssAuto;
    cbPageSize.Text := '10';
    cbPageSize.WidthStyle := ssAuto;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    ClaimAdjTable.SetParentComponent(Self);
    ClaimAdjTable.Name := 'ClaimAdjTable';
    ClaimAdjTable.Left := 16;
    ClaimAdjTable.Top := 80;
    ClaimAdjTable.Width := 850;
    ClaimAdjTable.Height := 360;
    ClaimAdjTable.HeightStyle := ssAuto;
    ClaimAdjTable.WidthStyle := ssAuto;
    ClaimAdjTable.BorderColor := clSilver;
    ClaimAdjTable.ElementFont := efCSS;
    ClaimAdjTable.ElementHeaderClassName := 'thead-light';
    ClaimAdjTable.ElementPosition := epIgnore;
    ClaimAdjTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    ClaimAdjTable.Columns.Clear;
    with ClaimAdjTable.Columns.Add do
    begin
      DataField := 'TransactionDate';
      Title := 'Transaction Date';
    end;
    with ClaimAdjTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'GiftAid';
      Title := 'Amount';
    end;
    with ClaimAdjTable.Columns.Add do
    begin
      DataField := 'ClaimStatus';
      Title := 'Status';
    end;
    with ClaimAdjTable.Columns.Add do
    begin
      DataField := 'AdjustmentType';
      Title := 'Type';
    end;
    with ClaimAdjTable.Columns.Add do
    begin
      DataField := 'LinkedDonationId';
      Title := 'Linked Donation';
    end;
    with ClaimAdjTable.Columns.Add do
    begin
      DataField := 'Comment';
      Title := 'Comment';
      Width := 200;
    end;
    ClaimAdjTable.DataSource := ClaimAdjSource;
    ClaimAdjCloseButton.SetParentComponent(Self);
    ClaimAdjCloseButton.Name := 'ClaimAdjCloseButton';
    ClaimAdjCloseButton.Left := 760;
    ClaimAdjCloseButton.Top := 480;
    ClaimAdjCloseButton.Width := 96;
    ClaimAdjCloseButton.Height := 25;
    ClaimAdjCloseButton.Caption := 'Close';
    ClaimAdjCloseButton.ElementClassName := 'btn btn-light';
    ClaimAdjCloseButton.ElementFont := efCSS;
    ClaimAdjCloseButton.ElementPosition := epIgnore;
    ClaimAdjCloseButton.HeightStyle := ssAuto;
    ClaimAdjCloseButton.WidthStyle := ssAuto;
    SetEvent(ClaimAdjCloseButton, Self, 'OnClick', 'ClaimAdjCloseButtonClick');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 280;
    lcPaginator.Top := 480;
    lcPaginator.Width := 280;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.Style := lsPagination;
    ClaimAdjSource.SetParentComponent(Self);
    ClaimAdjSource.Name := 'ClaimAdjSource';
    ClaimAdjSource.DataSet := ClaimAdjData;
    ClaimAdjSource.Left := 120;
    ClaimAdjSource.Top := 200;
    ClaimAdjData.SetParentComponent(Self);
    ClaimAdjData.Name := 'ClaimAdjData';
    ClaimAdjData.EntitySetName := 'Adjustment';
    ClaimAdjData.Connection := MainData.DataConnection;
    ClaimAdjData.Left := 48;
    ClaimAdjData.Top := 200;
    ClaimAdjDataId.SetParentComponent(ClaimAdjData);
    ClaimAdjDataId.Name := 'ClaimAdjDataId';
    ClaimAdjDataId.FieldName := 'Id';
    ClaimAdjDataTransactionDate.SetParentComponent(ClaimAdjData);
    ClaimAdjDataTransactionDate.Name := 'ClaimAdjDataTransactionDate';
    ClaimAdjDataTransactionDate.FieldName := 'TransactionDate';
    ClaimAdjDataGiftAid.SetParentComponent(ClaimAdjData);
    ClaimAdjDataGiftAid.Name := 'ClaimAdjDataGiftAid';
    ClaimAdjDataGiftAid.FieldName := 'GiftAid';
    SetEvent(ClaimAdjDataGiftAid, Self, 'OnGetText', 'ClaimAdjDataGiftAidGetText');
    ClaimAdjDataAmount.SetParentComponent(ClaimAdjData);
    ClaimAdjDataAmount.Name := 'ClaimAdjDataAmount';
    ClaimAdjDataAmount.FieldName := 'Amount';
    ClaimAdjDataClaimStatus.SetParentComponent(ClaimAdjData);
    ClaimAdjDataClaimStatus.Name := 'ClaimAdjDataClaimStatus';
    ClaimAdjDataClaimStatus.FieldName := 'ClaimStatus';
    ClaimAdjDataClaimStatus.Size := 25;
    ClaimAdjDataClaimId.SetParentComponent(ClaimAdjData);
    ClaimAdjDataClaimId.Name := 'ClaimAdjDataClaimId';
    ClaimAdjDataClaimId.FieldName := 'ClaimId';
    ClaimAdjDataTaxYear.SetParentComponent(ClaimAdjData);
    ClaimAdjDataTaxYear.Name := 'ClaimAdjDataTaxYear';
    ClaimAdjDataTaxYear.FieldName := 'TaxYear';
    ClaimAdjDataComment.SetParentComponent(ClaimAdjData);
    ClaimAdjDataComment.Name := 'ClaimAdjDataComment';
    ClaimAdjDataComment.FieldName := 'Comment';
    ClaimAdjDataComment.Size := 250;
    ClaimAdjDataAdjustmentType.SetParentComponent(ClaimAdjData);
    ClaimAdjDataAdjustmentType.Name := 'ClaimAdjDataAdjustmentType';
    ClaimAdjDataAdjustmentType.FieldName := 'AdjustmentType';
    ClaimAdjDataAdjustmentType.Size := 14;
    SetEvent(ClaimAdjDataAdjustmentType, Self, 'OnGetText', 'ClaimAdjDataAdjustmentTypeGetText');
    ClaimAdjDataLinkedDonationId.SetParentComponent(ClaimAdjData);
    ClaimAdjDataLinkedDonationId.Name := 'ClaimAdjDataLinkedDonationId';
    ClaimAdjDataLinkedDonationId.FieldName := 'LinkedDonationId';
    SetEvent(ClaimAdjDataLinkedDonationId, Self, 'OnGetText', 'ClaimAdjDataLinkedDonationIdGetText');
  finally
    ClaimAdjTitleLabel.AfterLoadDFMValues;
    lbPaginationInfo.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    ClaimAdjTable.AfterLoadDFMValues;
    ClaimAdjCloseButton.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    ClaimAdjSource.AfterLoadDFMValues;
    ClaimAdjData.AfterLoadDFMValues;
    ClaimAdjDataId.AfterLoadDFMValues;
    ClaimAdjDataTransactionDate.AfterLoadDFMValues;
    ClaimAdjDataGiftAid.AfterLoadDFMValues;
    ClaimAdjDataAmount.AfterLoadDFMValues;
    ClaimAdjDataClaimStatus.AfterLoadDFMValues;
    ClaimAdjDataClaimId.AfterLoadDFMValues;
    ClaimAdjDataTaxYear.AfterLoadDFMValues;
    ClaimAdjDataComment.AfterLoadDFMValues;
    ClaimAdjDataAdjustmentType.AfterLoadDFMValues;
    ClaimAdjDataLinkedDonationId.AfterLoadDFMValues;
  end;
end;

end.
